<script module lang="ts">
	function isPromise(c: StoryblokComponent<any, any, any>): c is AsyncComponent<any, any, any> {
		return (c as AsyncComponent<any, any, any>).then !== undefined;
	}
</script>

<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { getComponent, type StoryblokComponent, type AsyncComponent } from './sdk';
	import { type Component } from 'svelte';
	import { dev } from '$app/environment';
	import { storyblok } from '$lib/state/storyblok.svelte';

	interface Props {
		content: ISbStoryData['content'];
		placeholder?: Component<any, any, any>;
		[key: string]: any;
	}

	let { content, placeholder: Placeholder, ...other }: Props = $props();

	let SbComponent = $derived(
		content && content.component ? getComponent(content.component) : undefined
	);
</script>

{#snippet fallback()}
	{#if storyblok.editMode || dev}
		<div class="bg-red-500 p-4 text-xl text-white">
			<strong class="text-lg">[{dev ? 'DEV' : 'DO NOT PUBLISH'}]</strong>
			<strong class="px-2 text-lg italic">{content?.component ?? 'Unknown component'}</strong> not found
		</div>
	{/if}
{/snippet}

{#if SbComponent}
	{#if isPromise(SbComponent)}
		{#await SbComponent}
			{#if Placeholder}
				<Placeholder {...other} {content} />
			{/if}
		{:then { default: AsyncComponent }}
			<AsyncComponent {...other} {content} />
		{:catch}
			{@render fallback()}
		{/await}
	{:else}
		<SbComponent {...other} {content} />
	{/if}
{:else}
	{@render fallback()}
{/if}
